import { ArrowDown2 } from "iconsax-react-nativejs";
import { useState, useRef } from "react";
import { View, Text, Pressable, Modal, FlatList } from "react-native";
import { useTheme } from "@/src/styles/theme-provider";

type DropdownOption = Readonly<{
	label: string;
	value: string;
}>;

type ScDropdownProps = Readonly<{
	options: DropdownOption[];
	value: string;
	onChange: (value: string) => void;
	placeholder?: string;
	triggerClassName?: string;
	menuWidth?: number;
	menuMaxHeight?: number;
}>;

const ScDropdown = ({ options, value, onChange, placeholder = "Select...", triggerClassName = "py-2.5 md:py-3 bg-chalk", menuWidth, menuMaxHeight = 300 }: ScDropdownProps) => {
	const {themeVars} = useTheme();
	const [open, setOpen] = useState(false);
	const triggerRef = useRef<View>(null);
	const [triggerLayout, setTriggerLayout] = useState({ x: 0, y: 0, width: 0, height: 0 });

	const selected = options.find(o => o.value === value);

	const openDropdown = () => {
		triggerRef.current?.measure((fx, fy, width, height, px, py) => {
			setTriggerLayout({ x: px, y: py + height + 4, width, height });
			setOpen(true);
		});
	};

	return (
		<>
			<Pressable
				ref={triggerRef}
				onPress={openDropdown}
				className={`flex-row items-center justify-between px-4 self-stretch md:border md:border-ash-3 rounded-xl min-w-36 hover:bg-ash-3 ${triggerClassName}`}
			>
				<Text numberOfLines={1} className={`text-sm flex-1 mr-1 ${selected ? "text-onyx" : "text-ash-2"}`}>
					{selected?.label ?? placeholder}
				</Text>
				<ArrowDown2 size={18} color="var(--color-ash-2)" />
			</Pressable>

			<Modal visible={open} transparent animationType="none" onRequestClose={() => setOpen(false)}>
				<Pressable style={themeVars as any} className="flex-1" onPress={() => setOpen(false)}>
					<View
						style={{
							position: "absolute",
							top: triggerLayout.y,
							left: triggerLayout.x,
							width: menuWidth ?? triggerLayout.width,
							maxHeight: menuMaxHeight,
						}}
						className="bg-chalk border border-ash-3 rounded-xl overflow-hidden shadow-sm p-1"
					>
						<FlatList
							data={options}
							keyExtractor={(item) => item.value}
							showsVerticalScrollIndicator={false}
							renderItem={({ item }) => (
								<Pressable
									onPress={() => { onChange(item.value); setOpen(false); }}
									className={`px-4 py-3 rounded-xl hover:bg-ash-3 ${item.value === value ? "bg-ash-3" : "bg-chalk"}`}
								>
									<Text className="text-onyx">{item.label}</Text>
								</Pressable>
							)}
						/>
					</View>
				</Pressable>
			</Modal>
		</>
	);
};

export default ScDropdown;
